import { useEffect, useState } from 'react';

export const useImageIsLoaded = (src?: string): boolean => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!src) {
      setIsLoaded(false);
      return;
    }

    let isMounted = true;
    const image = new window.Image();

    image.onload = () => {
      if (isMounted) {
        setIsLoaded(true);
      }
    };
    image.onerror = () => {
      if (isMounted) {
        setIsLoaded(false);
      }
    };
    image.src = src;

    return () => {
      setIsLoaded(false);
      isMounted = false;
    };
  }, [src]);

  return isLoaded;
};
